import 'react';
import { CurvedContainer, CenteredGridUnit, RelativeContainer, JamImage } from '@lendi-jam/atoms';
import Grid from '@lendi-ui/grid';
import { Heading } from '@lendi-ui/typography';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { handleButtonTrackingEvent } from '@lendi-jam/tracking';
import { Button } from '@lendi-ui/button';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte, between } from '@lendi-ui/breakpoint';
import { mt, pb, mb, p } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { bg } from '@lendi-ui/color';
import Container from '@lendi-ui/container';

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1;
var ButtonGrid = styled(Grid)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var hasButtons = _ref.hasButtons;
  return mt(hasButtons ? 'xs' : 'nil');
}, mt('md'), gte('sm')(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    ", "\n  "])), mt('xxs')));
var ButtonContainer = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n  ", "\n  ", "\n"])), mt('sm'), gte('sm')(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n    ", "\n    width: initial;\n  "])), mt('lg')));

var Buttons = function Buttons(_ref) {
  var primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    variant = _ref.variant;
  return /*#__PURE__*/jsxs(ButtonGrid, {
    hasButtons: primaryButton || secondaryButton,
    gutter: "xs",
    wrap: true,
    children: [primaryButton && primaryButton.text && /*#__PURE__*/jsx(ButtonContainer, {
      children: /*#__PURE__*/jsx(Button, {
        size: "sm",
        variant: variant === 'dark' ? 'secondary' : 'primary',
        isFullWidth: true,
        href: embedMarketingTrackingIntoURL((primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.url) || ''),
        onClick: function onClick() {
          handleButtonTrackingEvent(_objectSpread(_objectSpread({}, primaryButton), {}, {
            variant: variant === 'dark' ? 'secondary' : 'primary'
          }));
        },
        children: primaryButton.text
      })
    }), secondaryButton && secondaryButton.text && /*#__PURE__*/jsx(ButtonContainer, {
      children: /*#__PURE__*/jsx(Button, {
        size: "sm",
        variant: variant === 'dark' ? 'secondary' : 'primary',
        isFullWidth: true,
        href: embedMarketingTrackingIntoURL((secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.url) || ''),
        onClick: function onClick() {
          handleButtonTrackingEvent(_objectSpread(_objectSpread({}, secondaryButton), {}, {
            variant: variant === 'dark' ? 'secondary' : 'primary'
          }));
        },
        children: secondaryButton.text
      })
    })]
  });
};
var Buttons$1 = Buttons;

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
var ImageContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  min-height: 20rem;\n"])));
var CategoryHeroContainer = styled(Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 20rem;\n  padding-top: 128px;\n  ", "\n\n  ", "\n"])), pb('xxxl'), gte('lg')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), mb('nil')));
var HeroBackground = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  position: relative;\n"])), function (_ref) {
  var variant = _ref.variant;
  return variant === 'dark' ? bg('secondary.700') : bg('shade.0');
});
var ImageBackground = styled(CurvedContainer)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  z-index: 0;\n\n  ", "\n"])), bg('primary.500'), between('xs', 'lg')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var ImageGridUnit = styled(Grid.Unit)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), between('xs', 'lg')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 100%;\n    ", "\n  "])), p('nil')));
var ImageCurvedContainer = styled(CurvedContainer)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n"])), between('xs', 'lg')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n   border-radius: 0;\n  "]))));
var CategoryHeroContentContainer = styled(CenteredGridUnit)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  justify-content: center;\n"])));

var CategoryHeroImage = function CategoryHeroImage(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    title = _ref.title,
    subtitle = _ref.subtitle,
    imageSharp = _ref.imageSharp,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'dark' : _ref$variant;
  return /*#__PURE__*/jsx(HeroBackground, {
    variant: variant,
    children: /*#__PURE__*/jsx(CategoryHeroContainer, {
      children: /*#__PURE__*/jsxs(Grid, {
        valign: "stretch",
        children: [/*#__PURE__*/jsxs(CategoryHeroContentContainer, {
          size: {
            xs: 1,
            sm: 5 / 6,
            md: 3 / 4,
            lg: 1 / 2,
            xl: 5 / 12
          },
          children: [title && /*#__PURE__*/jsx(Heading, {
            size: "xl",
            color: variant === 'dark' ? 'shade.0' : 'shade.800',
            children: title
          }), subtitle && /*#__PURE__*/jsx(Fragment, {
            children: /*#__PURE__*/jsx(Heading, {
              color: variant === 'dark' ? 'shade.0' : 'shade.800',
              mt: "md",
              size: "md",
              children: subtitle
            })
          }), /*#__PURE__*/jsx(Buttons$1, {
            variant: variant,
            primaryButton: primaryButton,
            secondaryButton: secondaryButton
          })]
        }), /*#__PURE__*/jsx(ImageGridUnit, {
          size: {
            xs: 1,
            lg: 5 / 12,
            xl: 1 / 2
          },
          offset: {
            xs: 0,
            lg: 1 / 12,
            xl: 1 / 12
          },
          children: /*#__PURE__*/jsxs(RelativeContainer, {
            children: [/*#__PURE__*/jsx(ImageCurvedContainer, {
              direction: "right",
              radius: "63px",
              children: /*#__PURE__*/jsx(ImageContainer, {
                children: imageSharp && /*#__PURE__*/jsx(JamImage, {
                  alt: alt,
                  placeholder: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.base64,
                  src: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.src,
                  srcSet: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.srcSet,
                  sizes: imageSharp === null || imageSharp === void 0 ? void 0 : imageSharp.sizes
                })
              })
            }), /*#__PURE__*/jsx(ImageBackground, {
              direction: "right"
            })]
          })
        })]
      })
    })
  });
};

export { CategoryHeroImage };
